import { Moment } from 'moment';
import { Profile } from '../../../../common/models/Profile';
import { Trace } from './Trace';
import { t } from 'i18next';

export enum ReportStatus {
  DONE = 'DONE',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
}

export const getReportStatusLabel = (status?: ReportStatus) => {
  switch (status) {
    case ReportStatus.DONE:
      return t('reportStatus.done');
    case ReportStatus.PENDING:
      return t('reportStatus.pending');
    case ReportStatus.FAILED:
      return t('reportStatus.failed');
    default:
      return t('reportStatus.unknown');
  }
};

export class Report {
  constructor(
    private readonly id: number,
    private readonly name: string,
    private readonly status: ReportStatus,
    private readonly createdAt: Moment,
    private readonly trace: Trace | null,
    private readonly profile: Profile | null
  ) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getStatus() {
    return this.status;
  }

  getCreatedAt() {
    return this.createdAt;
  }

  getTrace() {
    return this.trace;
  }

  getProfile() {
    return this.profile;
  }
}
